import { UserRole } from '@engelvoelkersamericas/common-ui';

import { Currency } from '@models';

export const EVA_DATE_FORMAT = 'YYYY-MM-DD';
export const EVA_CSV_DATE_FORMAT = 'MM/DD/YYYY'; // padding
export const EVA_CSV_DATE_FORMAT_ALTERNATE = 'M/D/YYYY'; // no padding
export const EVA_DATE_FORMAT_1 = 'yyyy/MM/dd';
export const ITEMS_PER_PAGE = 20;
export const PREFIX_OTHER_USER_URL = 'other-user';
export const PREFIX_OTHER_TEAM_URL = 'other-team';

export const PROTECT_PAGES_BY_ROLES = {
  OtherUserProfilePage: [UserRole.LICENSE_PARTNER, UserRole.OPERATIONS, UserRole.BROKERAGE_MANAGER, UserRole.HEAD_OFFICE],
};

const LARGE_SCREEN_BREAKPOINT = 1240;

export const SCREEN_BREAKPOINTS = {
  screenLG: LARGE_SCREEN_BREAKPOINT,
  screenLGMin: LARGE_SCREEN_BREAKPOINT,
  screenLGMax: LARGE_SCREEN_BREAKPOINT,
  screenXL: LARGE_SCREEN_BREAKPOINT + 1,
  screenXLMin: LARGE_SCREEN_BREAKPOINT + 1,
};

export const ONYX_ELITE = { name: 'Onyx Elite', label: 'Onyx Elite' };
export const RUBY_ELITE = { name: 'Ruby Elite', label: 'Ruby Elite' };
export const DIAMOND_ELITE = { name: 'Diamond Elite', label: 'Diamond Elite' };
export const CHAIRMANS_CIRCLE = { name: "Chairman's Circle", label: "Chairman's Circle" };
export const PRESIDENTS_CIRCLE = { name: "President's Circle", label: "President's Circle" };

export const AWARDS = [ONYX_ELITE, RUBY_ELITE, DIAMOND_ELITE, CHAIRMANS_CIRCLE, PRESIDENTS_CIRCLE];

export const AwardImages = [
  {
    name: ONYX_ELITE.name,
    image: '/content/images/elite-status/award-images/onyx_elite.svg',
  },
  {
    name: RUBY_ELITE.name,
    image: '/content/images/elite-status/award-images/ruby_elite.svg',
  },
  {
    name: DIAMOND_ELITE.name,
    image: '/content/images/elite-status/award-images/diamond_elite.svg',
  },
  {
    name: CHAIRMANS_CIRCLE.name,
    image: '/content/images/elite-status/award-images/chairmans_circle.svg',
  },
  {
    name: PRESIDENTS_CIRCLE.name,
    image: '/content/images/elite-status/award-images/presidents_circle.svg',
  },
];

export const PRODUCTION_OVERVIEW_LISTINGS = 'Listings';
export const PRODUCTION_OVERVIEW_PENDING = 'Pending';
export const PRODUCTION_OVERVIEW_CLOSED = 'Closed';
export const PRODUCTION_OVERVIEW_SIDES = 'Sides';
export const PRODUCTION_OVERVIEW_GCI = 'GCI';
export const PRODUCTION_OVERVIEW_LISTING_VOLUME = 'Listing Volume';
export const PRODUCTION_OVERVIEW_TRX_VOLUME = 'Trx Volume';
export const PRODUCTION_OVERVIEW_AVG_SALES_PRICE = 'Avg. Sales Price';
export const PRODUCTION_OVERVIEW_AVG_TIME_ON_MARKET = 'Avg. Time on market';

export enum SOCIAL_MEDIA_TYPE {
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  INSTAGRAM = 'instagram',
  LINKEDIN = 'linkedin',
  TIKTOK = 'tiktok',
  YOUTUBE = 'youtube',
  WHATSAPP = 'whatsapp',
  THREADS = 'threads',
  EV_INSIDER = 'evInsider',
}

export const SOCIAL_MEDIA_ICON: Record<SOCIAL_MEDIA_TYPE | 'default', string> = {
  facebook: 'content/images/contact-card/eva-facebook-colored.svg',
  twitter: 'content/images/contact-card/eva-twitter-x-icon.svg',
  instagram: 'content/images/contact-card/eva-instagram-colored.svg',
  linkedin: 'content/images/contact-card/eva-linkedin-colored.svg',
  tiktok: 'content/images/contact-card/eva-tiktok-icon.svg',
  youtube: 'content/images/contact-card/eva-youtube-icon.svg',
  whatsapp: 'content/images/contact-card/eva-whatsapp-icon.svg',
  threads: 'content/images/contact-card/eva-threads-icon.svg',
  evInsider: 'content/images/contact-card/eva-evinsider-icon.svg',
  default: 'content/images/contact-card/eva-social-media-placeholder.svg',
};

export const dateFormatDisplay = 'MM-DD-YYYY';
export const dateFormatSave = 'YYYY-MM-DD';
export const datePickerFormat = 'MM/DD/YYYY';

export const SocialMediaRegex: Record<SOCIAL_MEDIA_TYPE, RegExp> = {
  facebook: /^(https?:\/\/)?(www\.)?(facebook\.com|fb\.com)\/(profile\.php\?id=\d+|[a-zA-Z0-9.]+)\/?$/,
  instagram: /^(https?:\/\/)?(www\.)?(instagram\.com)\/([a-zA-Z0-9._]+)\/?$/,
  linkedin: /(https?:\/\/(www\.)|(www\.)?)?linkedin\.com\/(mwlite\/|m\/)?in\/[a-zA-Z0-9_.-]+\/?/,
  tiktok: /^(https?:\/\/)?(www\.)?(tiktok\.com)\/(@?[a-zA-Z0-9._]+)\/?$/,
  twitter: /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/(@?[a-zA-Z0-9_]+)\/?$/,
  youtube: /^(https?:\/\/)?(www\.)?(youtube\.com)\/(channel\/[a-zA-Z0-9_-]+|[a-zA-Z0-9_-]{11}|@[a-zA-Z0-9._-]+)(\/\w+)?\/?$/,
  whatsapp: /^(https?:\/\/)?wa\.me\/[0-9]+$/,
  threads: /^(https?:\/\/)?(www\.)?(threads\.com)\/(@?[a-zA-Z0-9._]+)\/?$/,
  evInsider: /^(https?:\/\/)?(www\.)?(app\.evrealestate\.com)\/(\w+)\.(\w+)\/?$/,
};

// Map of country names to currency codes
// If we add more currency conversion options, add them here
export const CURRENCY_MAP: Record<string, Currency> = {
  Canada: 'CAD',
};

export type OptionLanguageLabel = 'English' | 'French' | 'Spanish';
export type OptionLanguageValue = 'en' | 'fr' | 'sp';

export const BIO_LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'French' },
  { value: 'sp', label: 'Spanish' },
];

export const MEDIA_OPTIONS = [
  { label: 'Image', value: 'photo' },
  { label: 'Video', value: 'video' },
];

export const PRIOR_PRODUCTION_TEMPLATE_URL =
  'https://docs.google.com/spreadsheets/d/1AfgqlbDUcOimuH9rAHu92l_Pi6PosDfnaDpTCbdz8wg/edit?gid=0#gid=0';

// Codes are the values the API stores, decodes are the labels shown on screen
export const PriorProductionTypeOptions = [
  { code: 'seller', decode: 'Seller' },
  { code: 'buyer', decode: 'Buyer' },
  { code: 'tenant', decode: 'Tenant' },
  { code: 'landlord', decode: 'Landlord' },
  { code: 'referral', decode: 'Referrals' },
  { code: 'other', decode: 'Other' },
];

// Alternate spellings mapped to the canonical code: older stored rows still resolve, and the CSV import accepts
// the same aliases as the deals-service API
export const LegacyPriorProductionTypeMap: Record<string, string> = {
  referrals: 'referral',
  renter: 'tenant',
};

export enum EntityType {
  ADVISOR = 'advisor',
  TEAM = 'team',
}

export enum TeamRole {
  TEAM_MEMBER = 'TEAM MEMBER',
  TEAM_ADMIN = 'TEAM ADMIN',
}

export const PriorProductionTypeColorMap = {
  seller: 'green',
  buyer: 'blue',
  tenant: 'purple',
  landlord: 'yellow',
  referral: 'red',
  other: 'gray',
};
